import { render, staticRenderFns } from "./LandingSorteoBases.vue?vue&type=template&id=7d061bfa&scoped=true"
import script from "./LandingSorteoBases.vue?vue&type=script&lang=js"
export * from "./LandingSorteoBases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d061bfa",
  null
  
)

export default component.exports